  const optionGroup = [
    {
      label: "Sustainable & Social Enterprise",
      value: "sustainable_social",
      subcategories: [
        { label: "Eco friendly product", value: "eco_friendly" },
        { label: "NGOs", value: "ngos" },
        { label: "Upcycled products", value: "upcycled" },
        { label: "Women empowerment", value: "women_empowerment" },
        { label: "Communities", value: "communities" },
      ],
    },
    {
      label: "Media",
      value: "media",
      subcategories: [
        { label: "Radio", value: "radio" },
        { label: "Newspaper", value: "newspaper" },
        { label: "Digital portals", value: "digital_portals" },
        { label: "RJ", value: "rj" },
        { label: "Content creators", value: "content_creators" },
        { label: "Influencers", value: "influencers" },
      ],
    },
  ]
  const pulaActivityOptions = [
    { label: "Very Active", value: "very_active" },
    { label: "Somewhat Active", value: "somewhat_active" },
    { label: "Rarely Active", value: "rarely_active" },
    { label: "Just Joined", value: "just_joined" },
  ]

export {
  optionGroup,
  pulaActivityOptions,
};
